(function (angular) {
    'use strict';

    angular.module('Common')

        /**
         *
         */
        .factory('sharedDataService',
        ['$window', '$rootScope', function ($window, $rootScope) {
            var _types = {
                media: ['image', 'audio', 'video', 'application', 'text/*'],
                text: ['text']
            }
            var _billing;
            var _isInvoiced = true;
            var _spinning = false;
            var _countries = [];
            var _companyDetails;
            var _users;
            var _myProfile;
            var _possibleChannels = [];
            var fac = {
                getBilling: getBilling,
                setBilling: setBilling,
                getCompanyDetails: getCompanyDetails,
                setCompanyDetails: setCompanyDetails,
                isInvoiced: _isInvoiced,
                spinning: _spinning,
                getCountries: getCountries,
                setCountries: setCountries,
                getUsers: getUsers,
                setUsers: setUsers,
                addUser: addUser,
                updateUser: updateUser,
                deleteUser: deleteUser,
                getUsername: getUsername,
                getMyProfile: getMyProfile,
                setMyProfile: setMyProfile,
                getZeroBalanceWarning: getZeroBalanceWarning,
                setZeroBalanceWarning: setZeroBalanceWarning,
                clearCache: clearCache,
                getPossibleChannels: getPossibleChannels,
                setPossibleChannels: setPossibleChannels,
                checkIfTypeSupported: checkIfTypeSupported,
                checkIfTypesSupported: checkIfTypesSupported,
                checkIfAnyTypeSupported: checkIfAnyTypeSupported,
                getTypesMapping: getTypesMapping,
                getSupportedTypes: getSupportedTypes,
                getSupportedSuperTypes: getSupportedSuperTypes,
                getChannelContentTypeLimits: getChannelContentTypeLimits,
                getContentSizeLimitBytes: getContentSizeLimitBytes,
                getMessageLengthLimit: getMessageLengthLimit

            };

            return fac;

            function getChannelContentTypeLimits(channelId){
                var channelData = _possibleChannels.find(function(channel){
                    return channel.id === channelId;
                });
                if(channelData){
                    return channelData.contentTypeLimits || {};
                }
                return {};
            }

            function getTypesMapping(){
                return _types;
            }

            function _checkType(value, messageType){
                let result;
                try {
                    let regex = new RegExp("^" + value);
                    result = regex.test(messageType);
                } catch (e) {
                    result = value === messageType;
                }
                //if no match try matching the other way
                if(!result){
                    try {
                        let regex = new RegExp("^" + messageType);
                        result = regex.test(value);
                    } catch (e) {}
                }
                
                return result;
            }

            function checkIfTypeSupported(messageType, channelId){
                var channelData = _possibleChannels.find(function(channel){
                    return channel.id === channelId;
                });
                if(channelData){
                    if(channelData.supportedContentTypes && channelData.supportedContentTypes.length){
                        return channelData.supportedContentTypes.find(function(value){
                            return _checkType(value, messageType)
                        });
                    } else if (channelData.notSupportedContentTypes && channelData.notSupportedContentTypes.length){
                        return !channelData.notSupportedContentTypes.find(function(value){
                            return _checkType(value, messageType)
                        });
                    }
                }
                return true;
            }

            function checkIfTypesSupported(messageTypes, channelId){
                for(var index in messageTypes){
                    if(!checkIfTypeSupported(messageTypes[index], channelId)){
                        return false;
                    }
                };
                return true;
            }

            function checkIfAnyTypeSupported(messageTypes, channelId){
                var anyTrue = false;
                for(var index in messageTypes){
                    if(checkIfTypeSupported(messageTypes[index], channelId)){
                        anyTrue = true;
                    }
                };
                return anyTrue;
            }

            function getSupportedSuperTypes(channelId){
                var channelData = _possibleChannels.find(function(channel){
                    return channel.id === channelId;
                });
                if(channelData && channelData.supportedContentTypes && channelData.supportedContentTypes.length){
                    var result = [];
                    for(var type of _types.media){
                        if(channelData.supportedContentTypes.find((contentType) => contentType.startsWith(type))){
                            result.push(type);
                        }
                    }
                    return {
                        media: result,
                        text: _types.text
                    }
                }
                return _types;
            }

            function getSupportedTypes(messageTypes, channelId){
                var result = [];
                var channelData = _possibleChannels.find(function(channel){
                    return channel.id === channelId;
                });
                if(channelData){
                    if(channelData.supportedContentTypes && channelData.supportedContentTypes.length){
                        result = result.concat(channelData.supportedContentTypes.filter(function(value){
                            for(var index in messageTypes){
                                if(_checkType(value, messageTypes[index])){
                                    return true;
                                }
                            }
                            return false;
                        }));
                    }
                }
                return result;
            }

            function getContentSizeLimitBytes(channelId){
                var channelData = _possibleChannels.find(function(channel){
                    return channel.id === channelId;
                });
                if(channelData){
                    return channelData.contentSizeLimitBytes || -1;
                }
                return -1;
            }

            function getMessageLengthLimit(channelId){
                var channelData = _possibleChannels.find(function(channel){
                    return channel.id === channelId;
                });
                if(channelData){
                    return channelData.messageLengthLimit || -1;
                }
                return -1;
            }

            function getPossibleChannels(){
                return _possibleChannels;
            }
            function setPossibleChannels(possibleChannels){
                _possibleChannels = possibleChannels;
            }
            function clearCache() {
                _billing = undefined;
                _users = undefined;
                _companyDetails = undefined;
                _myProfile = undefined;
                _isInvoiced = true;
                _possibleChannels = [];
            }
            function setMyProfile(myProfile) {
                _myProfile = myProfile;
                $rootScope.$broadcast('myProfile:changed', myProfile);
            }
            function getMyProfile() {
                return _myProfile;
            }

            function getPossibleChannels() {
                return _possibleChannels;
            }
            function setPossibleChannels(possibleChannels) {
                _possibleChannels = possibleChannels;
            }
            function clearCache() {
                _billing = undefined;
                _users = undefined;
                _companyDetails = undefined;
                _myProfile = undefined;
                _isInvoiced = true;
                _possibleChannels = [];
            }
            function setMyProfile(myProfile) {
                _myProfile = myProfile;
                $rootScope.$broadcast('myProfile:changed', myProfile);
            }
            function getMyProfile() {
                return _myProfile;
            }

            function getBilling() {
                return _billing;
            }
            function setBilling(newBilling) {
                _billing = newBilling;
            }
            function getCountries() {
                return _countries;
            }
            function setCountries(countries) {
                if (Array.isArray(countries)) {
                    _countries = countries.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                }
            }
            function getUsers() {
                return _users;
            }
            function setUsers(users) {
                _users = users;
            }
            function addUser(user) {
                _users.push(user);
            }
            function updateUser(user) {
                _users[_users.map(function (x) { return x.userId; }).indexOf(user.userId)] = user;
            }
            function deleteUser(user) {
                _users.splice(_users.map(function (x) { return x.userId; }).indexOf(user.userId), 1);
            }

            function getUsername(userName) {
                if (!_users) {
                    if (userName.split(":").length < 2) {
                        return userName;
                    }
                    else {
                        return userName.split(":")[1];
                    }
                }
                var user = _users[_users.map(function (x) { return x.userName; }).indexOf(userName.split(":")[1])];
                if (user && user.firstName && user.lastName) {
                    return user.firstName + " " + user.lastName;
                }
                else if (user && user.userName) {
                    return user.userName;
                }
                else {
                    if (userName.split(":").length < 2) {
                        return userName;
                    }
                    else {
                        return userName.split(":")[1];
                    }
                }
            }

            function getCompanyDetails() {
                return _companyDetails;
            }

            function setZeroBalanceWarning(toggle) {
                $window.localStorage.setItem('zeroWarningAlreadyShown', toggle);
            }
            function getZeroBalanceWarning() {
                return $window.localStorage.getItem('zeroWarningAlreadyShown');
            }

            function setCompanyDetails(companyDetails) {
                _companyDetails = companyDetails;
            }

        }]);

})(window.angular);